import { getCookieValue } from "@/utilities/getCookieValue";
// The hub's own record of the Cookiebot decision, written by initCookiebot on
// accept / decline (and set to "true" outright where GDPR does not apply).
var HUB_CONSENT_COOKIE = {
    statistics: "cookieAnalytics",
    marketing: "cookieMarketing"
};
/**
 * Whether the user granted a Cookiebot category IN THE HUB.
 *
 * Reads the live window.Cookiebot.consent object and falls back to the hub's
 * own consent cookie only while uc.js is not on the page.
 *
 * Consent is never inferred from the presence of a vendor cookie: the
 * marketing site sets _ga on the registrable domain .360dialog.com under its
 * own banner decision, so a visitor can reach the hub already carrying a _ga
 * cookie the hub never had consent for. _gcl_aw is self-gating on marketing
 * consent (Conversion Linker is a marketing-category tag), but that says
 * nothing about statistics.
 */
export var hasConsent = function (category) {
    var _a, _b;
    if (typeof window === "undefined")
        return false;
    var live = (_b = (_a = window.Cookiebot) === null || _a === void 0 ? void 0 : _a.consent) === null || _b === void 0 ? void 0 : _b[category];
    if (typeof live === "boolean")
        return live;
    return getCookieValue(HUB_CONSENT_COOKIE[category]) === "true";
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc2VudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNvbnNlbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLDRCQUE0QixDQUFDO0FBSTVELDhFQUE4RTtBQUM5RSwyRUFBMkU7QUFDM0UsSUFBTSxrQkFBa0IsR0FBb0M7SUFDMUQsVUFBVSxFQUFFLGlCQUFpQjtJQUM3QixTQUFTLEVBQUUsaUJBQWlCO0NBQzdCLENBQUM7QUFFRjs7Ozs7Ozs7Ozs7O0dBWUc7QUFDSCxNQUFNLENBQUMsSUFBTSxVQUFVLEdBQUcsVUFBQyxRQUF5Qjs7SUFDbEQsSUFBSSxPQUFPLE1BQU0sS0FBSyxXQUFXO1FBQUUsT0FBTyxLQUFLLENBQUM7SUFFaEQsSUFBTSxJQUFJLEdBQUcsTUFBQSxNQUFBLE1BQU0sQ0FBQyxTQUFTLDBDQUFFLE9BQU8sMENBQUcsUUFBUSxDQUFDLENBQUM7SUFDbkQsSUFBSSxPQUFPLElBQUksS0FBSyxTQUFTO1FBQUUsT0FBTyxJQUFJLENBQUM7SUFFM0MsT0FBTyxjQUFjLENBQUMsa0JBQWtCLENBQUMsUUFBUSxDQUFDLENBQUMsS0FBSyxNQUFNLENBQUM7QUFDakUsQ0FBQyxDQUFDIn0=